import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Newnavigation from "../../components/new-navigation/new_navigation";
import PageBanner from "../../components/page-banner/page-banner";
import LearnMore from "../../components/common-learn-more/LearnMore";
import Footer from "../../components/footer/Footer";
import { HEALTHCARE_DETAIL_BG } from "../../assets/images/index";
import { healthcaredetail } from "../../utils/healthcarelearnmore";

const HealthCareDetail = () => {
  const type = useParams()?.type;
  useEffect(() => {
    document.getElementById(type).scrollIntoView();
  }, []);
  return (
    <div className="healthcare_detail">
      <Newnavigation />
      <PageBanner bg={HEALTHCARE_DETAIL_BG} title="Healthcare" />
      <LearnMore data={healthcaredetail} />
      <Footer />
    </div>
  );
};

export default HealthCareDetail;
